<template>
  <div class="screen-admin-page screen-admin-usaga-report">
    <div>
      <div class="toolbar">
        <div class="title">
          <h1>Projects</h1>
          <div class="search-overlay" v-if="val.openSearchTab">
            <div class="wrapper">
              <div class="header">
                <input type="text" v-model="val.inputVal" placeholder="Search">
                <button class="close-btn" @click="close()">X</button>
              </div>
              <div v-if="val.suggestionList" class="suggestion-list"
                :class="val.suggestionList && val.suggestionList.docs &&
                val.suggestionList.docs.length > 0 ? 'add-height': ''">
                <div>
                  <a :href="consoleLink+'admin/projects/'+item.key+'/preview/?search='+val.inputVal"
                    v-for="item in val.suggestionList.docs" :key="item.key" class="list-wrapper">
                    <div class="align-left">
                      <span>{{item.owner_name}}</span>
                    </div>
                    <div class="align-right">
                      <span>{{item.key}}</span>
                      <span>{{item.name}}</span>
                      <span>{{item.owner_email}}</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tools">
          <span class="search-icon"  @click="val.openSearchTab = true">
            Search
            <svg>
              <use v-bind="{'xlink:href':'#search-icon'}" />
            </svg>
          </span>
        </div>
      </div>
    </div>
    <rz-request-state :state="state" />
    <div
      class="usage-report admin-screen-content"
      v-if="state.status.isLoaded"
    >
      <FilterableView
        :filterables="filterables"
        @item-select="onSelectedFilteritem"
        @item-toggle="onFilterItemToggle"
      >
        <div class="item-list-row item-list">
          <div>
            <ProjectsActiveTable
              v-if="[ 'active', 'trial', 'verification' ].indexOf(itemGroup) > -1"
              :title="title"
              :total="totalItems"
              :projects="filteredProjects"
              @on-project-click="showPreviewProject"
            />
            <ProjectsTable
              v-else
              :title="title"
              :total="totalItems"
              :projects="filteredProjects"
              @on-project-click="showPreviewProject"
            />

            <div
              v-if="pages"
              class="filter-pagination"
            >
              <ul>
                <li
                  v-for="page in pages"
                  :key="page"
                >
                  <router-link
                    class="btn"
                    :to="{query: {...$route.query, page: page}}"
                  >{{page}}</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </FilterableView>
    </div>
    <QuickPreviewProjects v-if="previewProject"/>
  </div>
</template>
<script>
import {
  ref,
  reactive,
  onMounted,
  watch,
  computed,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { RequestState, RequestStateStatus } from '@/api/core';
import {
  ProjectList,
  FilterableItem,
  Filterables,
  ProjectGroup,
  DefaultProjectGroupsOrder,
} from '@/store/modules/admin';
import {
  ProjectStatus,
} from '@/store/modules/project';
import FilterableView from '@/components/admin/Filterable.vue';
import ProjectsTable from '@/components/admin/ProjectsTable.vue';
import ProjectsActiveTable from '@/components/admin/ProjectsActiveTable.vue';
import QuickPreviewProjects from '@/components/admin/QuickPreviewProjects.vue';
import Config from '@/config';

export default {
  components: {
    FilterableView,
    ProjectsTable,
    ProjectsActiveTable,
    QuickPreviewProjects,
  },
  data() {
    return {
      consoleLink: Config.consoleHost,
    };
  },
  setup() {
    const store = useStore();
    const pageLimit = 150;
    const route = useRoute();
    const router = useRouter();
    const state = ref(new RequestState());
    const projects = ref({});
    const previewProject = ref({});
    const filteredProjects = ref([]);
    const itemGroup = ref(route.query.group || 'active');
    const title = ref('Projects');
    const page = ref(route.query.page || 1);
    const filterables = ref(new Filterables({ items: [] }));
    const defaultProjectGroups = [...DefaultProjectGroupsOrder];
    const ignoreProjectGroups = ref([
      ProjectGroup.RoanuzDevelopers.value,
      ProjectGroup.RoanuzInternals.value,
      ProjectGroup.Test.value,
    ]);
    const ignoredStatus = ref([]);
    const val = reactive({
      openSearchTab: false,
      inputVal: null,
      suggestionList: {},
    });

    const showPreviewProject = (project) => {
      previewProject.value = project;
      if (route && route.query && route.query.group) {
        router.push({
          name: 'adminQuickProjectPreview',
          params: {
            type: route.query.group,
            key: project.key,
          },
          query: {
            page: page.value,
          },
        });
      } else {
        router.push({
          name: 'adminQuickProjectPreview',
          params: {
            type: 'active',
            key: project.key,
          },
          query: {
            page: page.value,
          },
        });
      }
    };

    // Need this function to load project using query param project key
    // eslint-disable-next-line no-unused-vars
    const showPreviewProjectUsingKey = (key) => {
      ProjectList.fetchProject(key).then((response) => {
        showPreviewProject(response);
      });
    };

    const hidePreviewProject = () => {
      previewProject.value = {};
      router.push({
        name: 'adminProjects',
      });
      store.commit('admin/updatePreviewProject', { project: null });
      return false;
    };

    const updateFilter = () => {
      const allItems = [...projects.value.projects];
      const projectGroups = {};
      const projectStatus = {};
      defaultProjectGroups.forEach((group) => {
        projectGroups[group.value] = {
          group,
          count: 0,
        };
      });

      const items = [
        new FilterableItem({
          name: 'Active',
          key: 'active',
          route: { query: { group: 'active' } },
        }),
        new FilterableItem({
          name: 'Trial',
          key: 'trial',
          route: { query: { group: 'trial' } },
        }),
        new FilterableItem({
          name: 'Verification',
          key: 'verification',
          route: { query: { group: 'verification' } },
        }),
        new FilterableItem({
          name: 'Incomplete',
          key: 'incomplete',
          route: { query: { group: 'incomplete' } },
        }),
        new FilterableItem({
          name: 'All',
          key: 'all',
          route: { query: { group: 'all' } },
        }),
        new FilterableItem({
          name: 'Pending',
          key: 'pending',
          route: { query: { group: 'pending' } },
        }),
      ];

      allItems.forEach((project) => {
        if (project.group && !projectGroups[project.group]) {
          const name = project.group.replace('_', ' ');
          projectGroups[project.group] = {
            group: { name },
            count: 0,
          };
        }

        if (!project.status) {
          project.status = ProjectStatus.Unknown;
        }

        if (!projectStatus[project.status.value]) {
          const name = project.status.value.replace('_', ' ');
          projectStatus[project.status.value] = {
            group: { name },
            count: 0,
          };
        }

        projectStatus[project.status.value].count += 1;
        projectGroups[project.group].count += 1;
      });

      if (projectGroups) {
        items.push(FilterableItem.SeperatorItem());
        Object.keys(projectGroups).forEach((key) => {
          const value = projectGroups[key];
          const name = value.group.key;
          items.push(
            new FilterableItem({
              name: `Hide ${name}`,
              key: `group||${key}`,
              isCheckbox: true,
              number: value.count,
              selected: ignoreProjectGroups.value.indexOf(key) > -1,
            }),
          );
        });
      }

      if (projectStatus && Object.keys(projectStatus).length > 1) {
        items.push(FilterableItem.SeperatorItem());
        Object.keys(projectStatus).forEach((key) => {
          const value = projectStatus[key];
          const { name } = value.group;
          items.push(
            new FilterableItem({
              name: `Hide ${name}`,
              key: `status||${key}`,
              isCheckbox: true,
              number: value.count,
              selected: ignoredStatus.value.indexOf(key) > -1,
            }),
          );
        });
      }

      filteredProjects.value = [...allItems];
      filteredProjects.value = filteredProjects.value.filter(
        (project) => ignoreProjectGroups.value.indexOf(project.group) < 0,
      );

      filteredProjects.value = filteredProjects.value.filter(
        (project) => ignoredStatus.value.indexOf(project.status.value) < 0,
      );

      filterables.value.activeItem = itemGroup.value;
      filterables.value.items = items;
      // showPreviewProjectUsingKey('RS_P_1382733182755016725');
    };

    const fetchData = () => {
      state.value.status = RequestStateStatus.Loading;
      let params = {};
      const group = itemGroup.value;

      if (group === 'active') {
        title.value = 'Active Projects';
        params = {
          show_active: 1,
          show_billing_verified: 1,
          show_active_free_trail_projects: 0,
        };
      } else if (group === 'trial') {
        title.value = 'Trial Projects';
        params = {
          show_active: 1,
          show_active_free_trail_projects: 1,
        };
      } else if (group === 'verification') {
        title.value = 'Billing verification req. Projects';
        params = {
          show_active: 1,
          show_billing_verification_required: 1,
        };
      } else if (group === 'incomplete') {
        title.value = 'Incomplete Projects';
        params = {
          show_active: 1,
          show_billing_not_available: 1,
        };
      } else if (group === 'pending') {
        title.value = 'Pending Status Projects';
        params = {
          show_active: 1,
          show_pending_status_payment_pending: 1,
        };
      }

      params = {
        limit: pageLimit,
        page: page.value,
        ignored_project_groups: ignoreProjectGroups.value.join(','),
        ignored_status: ignoredStatus.value.join(','),
        ...params,
      };

      return ProjectList.filterQuery(params).then((projectList) => {
        projects.value = projectList;
        filteredProjects.value = [...projectList.projects];
        state.value.status = RequestStateStatus.Loaded;
        updateFilter();
      }).catch((err) => {
        state.value.ref = err;
        state.value.status = RequestStateStatus.Error;
      });
    };

    const onSelectedFilteritem = () => {
    };

    const close = () => {
      val.suggestionList = null;
      val.inputVal = '';
      val.openSearchTab = false;
    };

    const onFilterItemToggle = (item) => {
      const keyParts = item.key.split('||');
      if (keyParts.length === 2) {
        const [filterKey, key] = keyParts;
        if (filterKey === 'group') {
          const index = ignoreProjectGroups.value.indexOf(key);
          if (index > -1) {
            ignoreProjectGroups.value.splice(index, 1);
          } else {
            ignoreProjectGroups.value.push(key);
          }
        } else if (filterKey === 'status') {
          const index = ignoredStatus.value.indexOf(key);
          if (index > -1) {
            ignoredStatus.value.splice(index, 1);
          } else {
            ignoredStatus.value.push(key);
          }
        }

        updateFilter();
      }
    };

    watch(() => route.query, () => {
      if (route.query.group || route.query.page) {
        itemGroup.value = route.query.group || 'active';
        page.value = route.query.page || 1;
        fetchData();
      }
    });
    watch(() => val.inputVal, () => ProjectList.searchQuery(val.inputVal, 'project').then((list) => {
      val.suggestionList = list.data.data;
    }));

    watch(() => filterables, () => {
      updateFilter();
    });

    onMounted(() => {
      fetchData();
    });

    const totalItems = computed(() => {
      if (projects.value.page.total_items) {
        return `${projects.value.page.total_items}`;
      }

      let length = `${projects.value.projects.length}`;
      if (projects.value.page && projects.value.page.total_pages > 1) {
        length = `${length}+`;
      }

      return length;
    });

    const pages = computed(() => {
      if (projects.value.page && projects.value.page.total_pages > 1) {
        const currentPage = parseInt(page.value, 10);
        const total = projects.value.page.total_pages;
        const maxPageItems = 10;
        const items = [];
        let left = 0;
        let right = Math.min(total, maxPageItems);
        if (total > maxPageItems) {
          left = Math.max(0, currentPage - (maxPageItems / 2));
          right = left + maxPageItems - 1;
        }
        for (let i = left; i < right; i += 1) {
          items.push(i + 1);
        }

        if (items[0] !== 1) {
          items.splice(0, 0, 1);
        }

        if (items[items.length - 1] !== total) {
          items.push(total);
        }

        return items;
      }
      return null;
    });

    const onPreviewUpdate = (project) => {
      previewProject.value = project;
    };

    return {
      state,
      projects,
      pages,
      totalItems,
      title,
      filteredProjects,
      filterables,
      onSelectedFilteritem,
      onFilterItemToggle,
      itemGroup,
      onPreviewUpdate,
      showPreviewProject,
      hidePreviewProject,
      previewProject,
      val,
      close,
    };
  },
};
</script>
